<template>
  <div class="lotto-type-page wrapper wrapper-content">
    <div class="container-fluid">
      <div class="row lottery-result">
        <div class="col-md-12">
          <div class="type-shell">
            <div class="type-tabs-wrap">
              <ul class="nav nav-tabs type-tabs">
                <li>
                  <router-link
                    :to="{ name: 'lottoresultbydate' }"
                    class="type-tab-link"
                    exact
                    active-class="is-active"
                  >
                    <i class="fa fa-fw fa-calendar"></i>
                    <span>ผลหวยเรียงตามวันที่</span>
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{ name: 'lottoresultbytype' }"
                    class="type-tab-link"
                    active-class="is-active"
                  >
                    <i class="fa fa-fw fa-list"></i>
                    <span>ผลหวยเรียงตามประเภท</span>
                  </router-link>
                </li>
              </ul>
            </div>

            <div class="type-panel">
              <div class="type-toolbar">
                <h2 class="type-toolbar__title">ตรวจผลหวยย้อนหลังตามประเภท</h2>
                <p class="type-toolbar__subtitle">
                  เลือกประเภทการละเล่นเพื่อดูผลย้อนหลัง
                </p>

                <div class="type-filter-row">
                  <div class="form-group">
                    <label>เลือกประเภทหวย</label>

                    <cool-select
                      v-model="selected"
                      :items="lotto_list_items"
                      item-value="name"
                      item-text="name"
                      @select="loadLottoResult"
                      placeholder="เลือกประเภทหวย"
                    />
                  </div>
                </div>
              </div>

              <div class="row m-t-sm m-b-sm">
                <div
                  class="col-xs-12"
                  v-for="(item, index) in lotto_result_data"
                  :key="'result-' + index"
                >
                  <div class="type-card">
                    <div class="type-card__header">
                      <h4 class="type-card__title">{{ item.description }}</h4>
                    </div>

                    <div class="type-card__body">
                      <table class="table table-bordered type-table">
                        <thead>
                          <tr v-if="item.lottotype_id > 2">
                            <th>สามตัวบน</th>
                            <th>สองตัวล่าง</th>
                          </tr>
                          <tr v-else>
                            <th>รางวัลที่ออก</th>
                            <th>สามตัวบน</th>
                            <th>สองตัวล่าง</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="item.lottotype_id > 2">
                            <td>
                              <span class="type-value" v-if="item.threetop">{{ item.threetop }}</span>
                              <span class="type-empty" v-else>รอผล</span>
                            </td>
                            <td>
                              <span class="type-value" v-if="item.twodown">{{ item.twodown }}</span>
                              <span class="type-empty" v-else>รอผล</span>
                            </td>
                          </tr>

                          <tr v-else>
                            <td>
                              <span class="type-value" v-if="item.full_result">{{ item.full_result }}</span>
                              <span class="type-empty" v-else>รอผล</span>
                            </td>
                            <td>
                              <span class="type-value" v-if="item.threetop">{{ item.threetop }}</span>
                              <span class="type-empty" v-else>รอผล</span>
                            </td>
                            <td>
                              <span class="type-value" v-if="item.twodown">{{ item.twodown }}</span>
                              <span class="type-empty" v-else>รอผล</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div><!-- /type-panel -->
          </div><!-- /type-shell -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { CoolSelect } from 'vue-cool-select'

moment.locale('th')

export default {
    name: 'lottoresultbytype',
    components: { CoolSelect },
    data () {
        return {
            date: new Date(),
            lotto_type: [],
            lotto_result: {},
            current_date: moment(new Date()).format('LL'),
            selected: 'หวยรัฐบาล',
            lotto_result_data: [],
            lotto_list_items: [],
            sp_index_list: [143, 144]
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            round: state => state.round.round
        })
    },
    methods: {
        async loadLottoResult (selectValue) {
            if (!selectValue || !selectValue.lottotype_id) return

            const lottotypeId = selectValue.lottotype_id
            const roundId = selectValue.round_id

            if (lottotypeId === 2) {
                try {
                    const typeData = {
                        order: 'desc',
                        limit: 10
                    }

                    const response = await this.$store.dispatch('lottoresult/getGovLottoResult', typeData)

                    this.lotto_result_data = response || []

                    for (let i = 0; i < this.lotto_result_data.length; i++) {
                        const item = this.lotto_result_data[i]
                        const thDate = this.formatThDate(item.date_result)

                        item.description = 'หวยรัฐบาล - ' + thDate
                        item.th_date_result = thDate

                        if (item.threefront && item.threeback) {
                            const [threefrontObj] = JSON.parse(item.threefront)
                            const [threebackObj] = JSON.parse(item.threeback)

                            item.threefront = threefrontObj.first + ' ' + threefrontObj.second
                            item.threeback = threebackObj.first + ' ' + threebackObj.second
                        }
                    }
                } catch (error) {
                    this.$toasted.error('There was an error connecting to the server.')
                }
            } else {
                try {
                    const typeData = {
                        lottotype_id: lottotypeId,
                        round_id: roundId,
                        order: 'desc',
                        limit: 10
                    }

                    let isSPindex = false

                    if (lottotypeId === 3) {
                        isSPindex = this.sp_index_list.includes(roundId)
                        if (isSPindex) {
                            typeData.limit = 31
                        }
                    }

                    const response = await this.$store.dispatch('lottoresult/getLottoResultByType', typeData)

                    this.lotto_result_data = []

                    for (let i = 0; i < response.length; i++) {
                        const item = response[i]

                        if (isSPindex) {
                            if (!item.full_result || item.full_result === 0) {
                                continue
                            }
                        }

                        const thDate = this.formatThDate(item.date_result)
                        item.description = item.description + ' - ' + thDate
                        item.th_date_result = thDate

                        this.lotto_result_data.push(item)
                    }
                } catch (error) {
                    this.$toasted.error('There was an error connecting to the server.')
                }
            }
        },

        formatDate (value) {
            if (value) {
                const date = new Date(value)
                return moment(date).format('DD/MM/YYYY HH:mm:ss')
            }
            return ''
        },

        formatThDate (value) {
            if (value) {
                const date = new Date(value)
                return moment(date).format('LL')
            }
            return ''
        },

        async loadRound () {
            try {
                if (this.round.length > 0 || this.round.goves || this.round.indexes) {
                    this.generateResultList(this.round)
                } else {
                    const response = await this.$store.dispatch('round/getAllRound')
                    this.generateResultList(response)
                }
            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        generateResultList (roundData) {
            this.lotto_list_items = []

            for (const key in roundData) {
                if (key === 'goves') {
                    const govesData = {
                        name: 'หวยรัฐบาล',
                        lottotype_id: 2
                    }

                    this.lotto_list_items.push(govesData)
                    this.loadLottoResult(govesData)
                    this.selected = 'หวยรัฐบาล'
                } else {
                    for (const roundId in roundData[key]) {
                        let lottotypeId = 3

                        if (key === 'yeekees') {
                            lottotypeId = 4
                        } else {
                            const round = roundData[key][roundId].round

                            if (round) {
                                if (round > 18 && round < 22) {
                                    continue
                                }
                            } else {
                                continue
                            }
                        }

                        this.lotto_list_items.push({
                            name: roundData[key][roundId].description,
                            lottotype_id: lottotypeId,
                            round_id: roundData[key][roundId].id
                        })
                    }
                }
            }
        }
    },
    created () {
        this.loadRound()
    }
}
</script>

<style lang="sass" scoped>
.lotto-type-page
  padding-top: 96px !important
  padding-bottom: 24px
  background: transparent

.type-shell
  position: relative
  z-index: 2

.type-tabs-wrap
  margin-bottom: 14px
  position: relative
  z-index: 3

.type-tabs
  display: flex
  flex-wrap: wrap
  gap: 10px
  border-bottom: 0
  margin: 0
  padding: 0
  list-style: none

.type-tabs > li
  float: none
  margin: 0

.type-tab-link
  display: inline-flex
  align-items: center
  justify-content: center
  gap: 8px
  min-height: 46px
  padding: 11px 18px
  border-radius: 14px
  border: 1px solid rgba(201, 165, 92, .24)
  background: rgba(26, 79, 75, .84)
  color: #e9f4f3 !important
  font-size: 14px
  font-weight: 600
  line-height: 1.2
  text-decoration: none !important
  box-shadow: 0 8px 18px rgba(26, 79, 75, .10)
  transition: background .2s ease, color .2s ease, border-color .2s ease, transform .2s ease, box-shadow .2s ease

.type-tab-link:hover,
.type-tab-link:focus
  background: rgba(35, 94, 89, .96)
  border-color: rgba(212, 178, 107, .42)
  color: #fff6df !important
  transform: translateY(-1px)
  text-decoration: none !important
  outline: none

.type-tab-link.is-active
  background: linear-gradient(135deg, #1A4F4B 0%, #235E59 50%, #2A6E6B 100%)
  border-color: rgba(201, 165, 92, .48)
  color: #fff6df !important
  box-shadow: 0 10px 24px rgba(26, 79, 75, .20)

.type-panel
  background: linear-gradient(180deg, rgba(255,255,255,.98) 0%, rgba(247,250,250,.98) 100%)
  border: 1px solid rgba(26, 79, 75, .10)
  border-radius: 20px
  box-shadow: 0 14px 40px rgba(26, 79, 75, .08)
  padding: 18px
  position: relative
  z-index: 1

.type-toolbar
  margin-bottom: 16px
  padding: 16px
  border-radius: 18px
  background: linear-gradient(135deg, #1A4F4B 0%, #235E59 50%, #2A6E6B 100%)
  border: 1px solid rgba(212, 178, 107, .22)

.type-toolbar__title
  margin: 0 0 10px
  font-size: 24px
  font-weight: 700
  color: #fff8ea

.type-toolbar__subtitle
  margin: 0 0 14px
  font-size: 14px
  line-height: 1.65
  color: rgba(220, 240, 238, .84)

.type-filter-row
  display: flex
  flex-wrap: wrap
  gap: 12px

.type-filter-row .form-group
  flex: 1 1 220px
  margin-bottom: 0

.type-filter-row label
  display: block
  margin-bottom: 8px
  font-size: 13px
  font-weight: 600
  color: #f5f1e6

.type-card
  margin-bottom: 16px
  border-radius: 18px
  overflow: hidden
  background: #ffffff
  border: 1px solid rgba(26, 79, 75, .10)
  box-shadow: 0 8px 22px rgba(26, 79, 75, .06)

.type-card__header
  padding: 14px 16px
  border-bottom: 1px solid rgba(26, 79, 75, .08)
  background: linear-gradient(135deg, rgba(248, 251, 251, 1) 0%, rgba(240, 247, 247, 1) 100%)

.type-card__title
  margin: 0
  font-size: 20px
  font-weight: 700
  color: #1A4F4B

.type-card__body
  padding: 0

.type-table
  margin-bottom: 0

.type-table > thead > tr > th
  background: #edf3f3
  color: #1A4F4B !important
  border-color: #cfe0df !important
  font-size: 14px
  font-weight: 700
  padding: 14px 16px

.type-table > tbody > tr > td,
.type-table > tbody > tr > th
  border-color: #daeaea !important
  padding: 14px 16px
  background: #ffffff
  color: #1e2e2d

.type-table > tbody > tr:nth-child(even) > td,
.type-table > tbody > tr:nth-child(even) > th
  background: #f8fcfc

.type-value
  font-weight: 700
  color: #184eb8

.type-empty
  font-weight: 600
  color: #8b9a9a

/* vue-cool-select */
::v-deep .cool-select
  width: 100%
  font-family: inherit

::v-deep .cool-select .toggle
  min-height: 46px
  border-radius: 14px !important
  border: 1px solid rgba(212, 178, 107, .30) !important
  background: rgba(255,255,255,.96) !important
  color: #173321 !important
  box-shadow: none !important
  display: flex
  align-items: center
  font-size: 14px
  font-weight: 600

::v-deep .cool-select .toggle:focus,
::v-deep .cool-select.open .toggle
  border-color: #d7b066 !important
  box-shadow: 0 0 0 2px rgba(215, 176, 102, .14) !important

::v-deep .cool-select .toggle .selected-item,
::v-deep .cool-select .toggle .placeholder,
::v-deep .cool-select .toggle .input
  color: #173321 !important
  font-size: 14px !important
  font-weight: 600 !important

::v-deep .cool-select .dropdown
  border-radius: 14px !important
  overflow: hidden
  border: 1px solid rgba(212, 178, 107, .24) !important
  background: #ffffff !important
  box-shadow: 0 16px 40px rgba(26, 79, 75, .16)
  z-index: 9999 !important

::v-deep .cool-select .item
  color: #173321 !important
  background: #ffffff !important
  padding: 12px 14px
  font-size: 14px !important
  font-weight: 600 !important

::v-deep .cool-select .item *
  color: inherit !important
  font-size: inherit !important
  font-weight: inherit !important

::v-deep .cool-select .item:hover
  background: #edf3f3 !important
  color: #1A4F4B !important

::v-deep .cool-select .item.selected
  background: linear-gradient(135deg, #1A4F4B 0%, #235E59 100%) !important
  color: #fff6df !important

::v-deep .cool-select .item.selected *
  color: #fff6df !important

@media (max-width: 991px)
  .lotto-type-page
    padding-top: 84px !important

  .type-panel
    padding: 14px

  .type-toolbar
    padding: 14px

  .type-toolbar__title
    font-size: 22px

  .type-card__title
    font-size: 18px

@media (max-width: 767px)
  .lotto-type-page
    padding-top: 76px !important
    padding-bottom: 18px

  .type-tabs
    gap: 8px

  .type-tabs > li
    width: 100%

  .type-tab-link
    width: 100%

  .type-panel
    border-radius: 18px
    padding: 12px

  .type-toolbar
    padding: 13px
    border-radius: 16px

  .type-toolbar__title
    font-size: 20px

  .type-toolbar__subtitle
    font-size: 13px

  .type-filter-row .form-group
    flex: 1 1 100%

  .type-card
    border-radius: 16px

  .type-card__header
    padding: 12px 14px

  .type-card__title
    font-size: 17px

  .type-table
    table-layout: fixed

  .type-table > thead > tr > th,
  .type-table > tbody > tr > td,
  .type-table > tbody > tr > th
    padding: 10px 10px
    word-break: break-word

::v-deep .IZ-select
  font-family: inherit !important

::v-deep .IZ-select__value,
::v-deep .IZ-select__input,
::v-deep .IZ-select__placeholder,
::v-deep .IZ-select__single-value
  color: #173321 !important
  font-size: 14px !important
  font-weight: 600 !important

::v-deep .IZ-select__menu,
::v-deep .IZ-select__menu-list
  background: #ffffff !important
  border-radius: 14px !important

::v-deep .IZ-select__item
  color: #173321 !important
  background: #ffffff !important
  font-size: 14px !important
  font-weight: 600 !important

::v-deep .IZ-select__item *
  color: inherit !important

::v-deep .IZ-select__item:hover
  color: #1A4F4B !important
  background: #edf3f3 !important

::v-deep .IZ-select__item--selected,
::v-deep .IZ-select__item.is-selected
  color: #fff6df !important
  background: linear-gradient(135deg, #1A4F4B 0%, #235E59 100%) !important

::v-deep .IZ-select__item--selected *,
::v-deep .IZ-select__item.is-selected *
  color: #fff6df !important

.type-tabs > li > a,
.type-tabs > li > a:hover,
.type-tabs > li > a:focus,
.type-tabs > li > a:active
  opacity: 1 !important
  visibility: visible !important
  display: inline-flex !important
  color: #e9f4f3 !important
  background: rgba(26, 79, 75, .84) !important
  text-decoration: none !important

.type-tabs > li > a.router-link-exact-active,
.type-tabs > li > a.is-active
  color: #fff6df !important
  background: linear-gradient(135deg, #1A4F4B 0%, #235E59 50%, #2A6E6B 100%) !important

</style>